import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const OTPLayout = loadable(
  async () => import("~/features/otp/pages/OTPLayout"),
  { fallback: <></> },
)
const OTPPage = loadable(
  async () => import("~/features/otp/pages/OTPView"),
  { fallback: <></> },
)

export const otpRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.otp,
    element: <OTPLayout />,
    children: [{ index: true, element: <OTPPage /> }],
  },
]
